import { z } from 'zod/v4';
import {
  CUSTOM_TILE_SCHEMA,
  DEFAULT_CUSTOM_TILE_DIRECT_TICKET,
  DEFAULT_CUSTOM_TILE_SUBSCRIPTION,
  ICustomTile,
} from './custom-tile.interfaces';

import { INormalText, NORMAL_TEXT_SCHEMA } from './text/text.interfaces';
import { EEntityType, ERelationType } from './text-relation-type.enums';
import { ETextType } from './text/text.enums';
import { Brand } from '../branded-types';
import { LanguagePrefix } from './language.interfaces';

export type CustomTileSectionId = Brand<string, 'customTileSectionId'>;

export const CUSTOM_TILE_SECTION_SCHEMA: z.ZodType<ICustomTileSection> =
  z.object({
    id: z
      .string()
      .transform((s: string) => s as CustomTileSectionId)
      .optional(),
    position: z.number(),
    texts: z.array(NORMAL_TEXT_SCHEMA),
    tiles: z.array(CUSTOM_TILE_SCHEMA),
  });

export const CUSTOM_TILE_SECTIONS_SCHEMA: z.ZodType<ICustomTileSection[]> =
  z.array(CUSTOM_TILE_SECTION_SCHEMA);

export interface ICustomTileSection {
  id?: CustomTileSectionId;
  position: number;
  texts: INormalText[];
  tiles: ICustomTile[];
}

export const DEFAULT_CUSTOM_TILE_SECTION: ICustomTileSection = {
  position: 0,
  texts: [
    {
      textType: ETextType.Web,
      entityType: EEntityType.customTileSection,
      relationType: ERelationType.title,
      text: {
        values: [
          {
            languagePrefix: 'DE' as LanguagePrefix,
            value: ' Willkommen im Amcon Webshop',
          },
        ],
      },
    },
  ],
  tiles: [DEFAULT_CUSTOM_TILE_DIRECT_TICKET, DEFAULT_CUSTOM_TILE_SUBSCRIPTION],
};
